import * as React from 'react';

import { useSelector } from 'react-redux';

import { ActionAfterViewed } from '@cian/action-after-viewed-component';

import { NBSP } from '../../constants/symbols';

import { ContentSection } from '../../components/ContentSection';
import { ChartOffersCountContainer } from '../Charts';
import { DynamicInfo } from '../../components/DynamicInfo';
import { getChartsData } from '../../selectors';
import { EBlockInPageName } from '../../types/share';
import { trackBlockInPageViewed } from '../../tracking';
import { ACTION_AFTER_VIEWED_TIMEOUT } from '../../constants/actionAfterViewed';

export function ContentOffersCountContainer() {
  const chartData = useSelector(getChartsData('supply'));

  const trackViewed = React.useCallback(() => {
    trackBlockInPageViewed(EBlockInPageName.Supply);
  }, []);

  if (chartData && chartData.block) {
    return (
      <ActionAfterViewed callback={trackViewed} timeoutCallback={ACTION_AFTER_VIEWED_TIMEOUT}>
        <ContentSection
          title="Предложение жилья"
          description={`Предложение — экспонируемые объекты на${NBSP}рынке по${NBSP}оценке Циан. За${NBSP}100% принято количество объектов в${NBSP}январе${NBSP}2020`}
          mainContent={<DynamicInfo trend={chartData.block.trend} title={chartData.block.title} />}
          chart={<ChartOffersCountContainer />}
        />
      </ActionAfterViewed>
    );
  }

  return null;
}
